import { create } from "zustand";

export const WALLET_SIGNER_STATUS = {
  UNKNOWN: "unknown",
  READY: "ready",
  LOCKED: "locked",
} as const;

export type WalletSignerStatus = (typeof WALLET_SIGNER_STATUS)[keyof typeof WALLET_SIGNER_STATUS];

type WalletSignerStatusStore = {
  mainEvmSignerStatus: WalletSignerStatus;
  solanaSignerStatus: WalletSignerStatus;
  setMainEvmSignerStatus: (status: WalletSignerStatus) => void;
  setSolanaSignerStatus: (status: WalletSignerStatus) => void;
};

export const useWalletSignerStatusStore = create<WalletSignerStatusStore>((set) => ({
  mainEvmSignerStatus: WALLET_SIGNER_STATUS.UNKNOWN,
  solanaSignerStatus: WALLET_SIGNER_STATUS.UNKNOWN,
  setMainEvmSignerStatus: (status) => set({ mainEvmSignerStatus: status }),
  setSolanaSignerStatus: (status) => set({ solanaSignerStatus: status }),
}));
